
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partenaires/[slug]",
      function () {
        return require("private-next-pages/partenaires/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partenaires/[slug]"])
      });
    }
  